export function positiveMod(value: number, mod: number): number {
	return ((value % mod) + mod) % mod
}
